export default __webpack_public_path__ + "static/media/try-img.234da012.jpg";